<template>
  <el-container class="app-wrapper">
    <el-header height="80">
      <app-header />
    </el-header>
    <el-main class="flex overflow-hidden">
      <vue-progress-bar />

      <template v-if="isAuthenticated">
        <side-menu />
        <GridContainer
          v-loading="loading"
          class="flex-1"
          element-loading-text="Almost There..."
        >
          <router-view />
        </GridContainer>
      </template>
      <template v-else>
        <router-view />
      </template>
    </el-main>
  </el-container>
</template>

<script>

import Header from '@/components/Header/Header'
import SideMenu from '@/components/SideMenu/SideMenu'

export default {
  name: 'App',
  components: {
    'app-header': Header,
    SideMenu
  },
  computed: {
    loading() {
      const dashboardStatistics = this.$store.getters.dashboardStatistics
      return Object.keys(dashboardStatistics).length <= 0
    }
  }
}
</script>

<style src="@/assets/stylesheets/app.scss" lang="scss" ></style>
